import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, merge, Observable, startWith, switchMap, tap } from 'rxjs';
interface Response {
  field: string,
  value: string
}
@Component({
  selector: 'app-article-filter',
  standalone: false,
  templateUrl: './article-filter.html',
  styleUrl: './article-filter.less'
})
export class ArticleFilter implements OnInit {
  article = new FormControl('');
  origin = new FormControl('');
  variety = new FormControl('');
  articleChange$!: Observable<any>;
  originChange$!: Observable<any>;
  varietyChange$!: Observable<any>;
  @Output() articleFilter = new EventEmitter<Response>();

  ngOnInit(): void {
    this.articleChange$ = this.article.valueChanges.pipe(
      map(value => ({ field: 'article', value: value })),
      debounceTime(300),
      startWith({ field: 'article', value: '' })
    );

    this.originChange$ = this.origin.valueChanges.pipe(
      map(value => ({ field: 'origin', value: value })),
      debounceTime(300),
      startWith({ field: 'origin', value: '' })
    );
    this.varietyChange$ = this.variety.valueChanges.pipe(
      map(value => ({ field: 'variety', value: value })),
      debounceTime(300),
      startWith({ field: 'variety', value: '' })
    );

    merge(this.articleChange$, this.originChange$, this.varietyChange$)
      .pipe(
        tap(({ field, value }) => {
          console.log(field, value);
          const filterValue: Response = {
            field: field,
            value: value,
          }
          this.articleFilter.emit(filterValue);
        })
      ).subscribe();
  }
  getUpdatedSellerCatalog(event: any) {
    // console.log(event.target.id);
    // console.log(event.target.value);

    // const filterValue :Response={
    //   field:event.target.id,
    //   value:event.target.value,
    // }
    // this.articleFilter.emit(filterValue);


  }
  clearValue(field: string) {
    if (field === 'article') {
      this.article.reset();
    }
    if (field === 'origin') {
      this.origin.reset();
    }
    if (field === 'variety') {
      this.variety.reset();
    }
  }
}
